import React, {Component} from 'react';
import logo from '../../images/logo_black.svg'
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Dispatch} from "redux";
import {ActionType, reducerStoreType} from "../../reducers/types";
import {injectIntl, IntlShape} from 'react-intl';
import {connect} from "react-redux";
import {PrimaryButton, WhiteButton} from "../../components/CustomUIComp/CustomFormElem";
import {RouteComponentProps} from "react-router";

interface IProps extends RouteComponentProps<any>{
    dispatch: Dispatch<ActionType<any>>,
    intl: IntlShape,
    countdown: number
}

interface IState {
    email: string
}
class Forgot extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            email: ''
        }
    }
    handleEmailChange = (e: any): void => {
        this.setState({email: e.target.value})
    }
    _check = (): boolean => {
        let {intl} = this.props
        if (!this.state.email) {
            toast(intl.formatMessage({id: 'userNameNotNull'}));
            return false
        }
        return true
    }
    confirm = () => {
        if (this._check()) {
            let params = {
                clientId: 'h5',
                email: this.state.email,
            }
            this.props.dispatch({type: 'FORGOT_PASSWORD', payload: params})
        }
    }
    toLogin = () => {
        this.props.history.replace('/login')
    }

    public render() {
        return (
            <div className="LoginPage">
                <div className="topBar">
                    <img src={logo} alt="logo" className="logo"/>
                </div>
                <div className="LoginForm">
                    <h2>{this.props.intl.formatMessage({id: 'findPassword'})}</h2>
                    <div>{this.props.intl.formatMessage({id: 'findPasswordTips'})}</div>
                    <div className="formLine">
                        {/*<label>{this.props.intl.formatMessage({id: 'email'})}</label>*/}
                        <input placeholder={this.props.intl.formatMessage({id:'email'})}
                               value={this.state.email} onChange={this.handleEmailChange}/>
                    </div>
                    <div className="buttons">
                        <PrimaryButton disabled={this.props.countdown > 0} className="confirmButtom" onClick={this.confirm}>
                            {
                                this.props.countdown === 0?
                                    this.props.intl.formatMessage({id: 'send'}) :
                                    this.props.intl.formatMessage({id: 'reSendText'}, {second: this.props.countdown})
                            }
                        </PrimaryButton>
                        <WhiteButton className="backButton" onClick={this.toLogin}>
                            {this.props.intl.formatMessage({id: 'backToLogin'})}
                        </WhiteButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType)=>{
    return {
        countdown: state.app.resetButtonCountDown
    }
})(Forgot));

